import { createAction } from '@reduxjs/toolkit';

import types from '../actionTypes';

export const setCareer = createAction(types.SET_CAREER);
export const addCareer = createAction(types.ADD_CAREER);
export const changeCareer = createAction(types.UPDATE_CAREER);
export const deleteCareer = createAction(types.DELETE_CAREER);
